<template>
  <v-data-table disable-pagination dense hide-default-footer :headers="headers" :items="productItem">
    <template v-slot:item.srNo="{ item }">
      {{ productItem.indexOf(item) + 1 }}
    </template>
    <template v-slot:item.Margin_Value="{item}">
      {{ item.Margin_Value.toFixed(2) }}
    </template>
    <template v-slot:item.Total_Selling_Price="{ item }">
      {{ (item.BOM_Quantity * item.Total_Selling_Price).toFixed(2) }}
    </template>
    <template v-slot:item.Total_Base_Price="{ item }">
      {{ (item.BOM_Quantity * item.Total_Base_Price).toFixed(2) }}
    </template>
    <template v-slot:item.Total_Margin_Value="{ item }">
      {{ ((item.BOM_Quantity * item.Total_Selling_Price) - (item.BOM_Quantity * item.Total_Base_Price)).toFixed(2) }}
    </template>
    <template v-slot:item.MarginPercentage="{ item }">
      {{ getRowDataMarginPercentage(item) }}
    </template>
    <template v-slot:body.append>
      <tr>
        <td colspan="8"></td>
        <td>{{ getTotalSellingPrice(productItem) }}</td>
        <td>{{ getTotalBaseCost(productItem) }}</td>
        <td>{{ getTotalMargin(productItem) }}</td>
        <td>{{ getTotalMarginPercentage(productItem) }}</td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'productDataTable',
  props: {
    product: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    }
  },
  watch: {
    product: {
      handler: function (newVal) {
        this.productItem = (newVal && newVal.length > 0) ? newVal : []
      },
      deep: true
    }
  },
  data () {
    return {
      headers: [
        { text: 'S.No', sortable: true, value: 'srNo' },
        { text: 'Product ID', sortable: true, value: 'Product_ID' },
        { text: 'Product Name', sortable: true, value: 'Product_Name' },
        { text: 'Product Description', sortable: true, value: 'Product_Description' },
        { text: 'BOM Quantity', sortable: true, value: 'BOM_Quantity' },
        { text: 'Selling Price', sortable: true, value: 'Selling_Price' },
        { text: 'Base Cost', sortable: true, value: 'Base_Cost' },
        { text: 'Margin Value', sortable: true, value: 'Margin_Value' },
        { text: 'Total Selling Price', sortable: true, value: 'Total_Selling_Price' },
        { text: 'Total Base Cost', sortable: true, value: 'Total_Base_Price' },
        { text: 'Total Margin Value', sortable: true, value: 'Total_Margin_Value' },
        { text: 'Margin %', sortable: true, value: 'MarginPercentage' }
      ],
      productItem: (this.product && this.product.length > 0) ? this.product : []
    }
  },
  methods: {
    getTotalSellingPrice: function (items) {
      let total = 0
      items.forEach(obj => {
        if (obj.BOM_Quantity && obj.Total_Selling_Price) {
          total += (obj.BOM_Quantity * obj.Total_Selling_Price)
        }
      })
      return total.toFixed(2)
    },
    getTotalBaseCost: function (items) {
      let total = 0
      items.forEach(obj => {
        if (obj.BOM_Quantity && obj.Total_Base_Price) {
          total += (obj.BOM_Quantity * obj.Total_Base_Price)
        }
      })
      return total.toFixed(2)
    },
    getTotalMargin: function (items) {
      let total = 0
      items.forEach(obj => {
        total += (obj.BOM_Quantity * obj.Total_Selling_Price).toFixed(2) - (obj.BOM_Quantity * obj.Total_Base_Price).toFixed(2)
      })
      return total.toFixed(2)
    },
    getTotalMarginPercentage: function (items) {
      let marginPercentage = 0
      let totalMarginValue = parseFloat(this.getTotalMargin(items))
      let totalSellingCost = parseFloat(this.getTotalSellingPrice(items))
      if (totalMarginValue && totalSellingCost) {
        marginPercentage = ((totalMarginValue) / (totalSellingCost)) * 100
      }
      return `${marginPercentage.toFixed(2)}%`
    },
    getRowDataMarginPercentage: function (item) {
      let totalMarginValue = (parseFloat(item.BOM_Quantity * item.Total_Selling_Price) - parseFloat(item.BOM_Quantity * item.Total_Base_Price)).toFixed(2)
      let totalSellingCost = parseFloat((item.BOM_Quantity * item.Total_Selling_Price))

      let rowMargin = 0
      if (totalMarginValue && totalSellingCost) {
        rowMargin = (totalMarginValue / totalSellingCost) * 100
      }
      return `${rowMargin.toFixed(2)}%`
    }
  }
}
</script>
